export default __webpack_public_path__ + "static/media/logo-bianco.ebc80ed8.png";